import { useCallback, useEffect, useState } from "react";
import { getVehicleUrlOverride } from "./vehicleUrlOverride";
import { LINKS } from "../config/links";

// Resolves the exact URL a vehicle's "Ver anuncio" button must use:
// 1) a local /content-admin override for this vehicle, if present
// 2) the vehicle's own `url` field (src/data/featuredVehicles.ts)
// 3) LINKS.exploreUrl as a last-resort fallback only when both are empty
export function useVehicleAdUrl(vehicleId: number, fallbackUrl: string): string {
  const resolve = useCallback(
    () => getVehicleUrlOverride(vehicleId) || fallbackUrl || LINKS.exploreUrl,
    [vehicleId, fallbackUrl],
  );

  const [url, setUrl] = useState(resolve);

  useEffect(() => {
    setUrl(resolve());
  }, [resolve]);

  return url;
}
